import { type SearchRequest } from '@searchkit/api';

import { createResponseFactory } from '~/search-domain/pipelines/betting-splits/response-factory';
import { type BettingSplitsESResultBody } from '~/search-domain/pipelines/betting-splits/types';
import { type SearchDomainContext } from '~/search-domain/types';
import { createElasticSearchContext, createResponseFactoryContext, isFacetOnlyRequest } from '~/search-domain/utils';

export async function transformBettingSplitsResponse(
  context: SearchDomainContext,
  { searchRequest, searchResponse }: { searchRequest: SearchRequest; searchResponse: BettingSplitsESResultBody },
) {
  if (isFacetOnlyRequest(searchRequest)) {
    return searchResponse;
  }

  const hitsPerPage = searchRequest.request?.params?.hitsPerPage ?? 10;
  const page = searchRequest.request?.params?.page ?? 0;
  const from = page * hitsPerPage;

  const elasticContext = createElasticSearchContext(context);

  return createResponseFactory.call(
    createResponseFactoryContext(context),
    elasticContext,
    searchResponse,
    from,
    hitsPerPage,
  );
}
